import { useDispatch } from 'store/hooks';
import {
    createToggleGridColumnSortAction,
    createToggleGridSingleColumnSortAction,
} from './actions';
import { useWidgetContext } from 'widgets/WidgetContext';
import { useCallback, useMemo } from 'react';

export const useDispatchWidgetToggleColumnSort = <T extends string>() => {
    const { widgetType, widgetKey } = useWidgetContext();
    const dispatch = useDispatch();
    const actionCreator = useMemo(
        () => createToggleGridColumnSortAction(widgetType, widgetKey),
        [widgetType, widgetKey]
    );
    return useCallback(
        (columnId: T, defaultSortDesc: boolean) =>
            dispatch(actionCreator(columnId, defaultSortDesc)),
        [dispatch, actionCreator]
    );
};

export const useDispatchWidgetToggleSingleColumnSort = <T extends string>() => {
    const { widgetType, widgetKey } = useWidgetContext();
    const dispatch = useDispatch();
    const actionCreator = useMemo(
        () => createToggleGridSingleColumnSortAction(widgetType, widgetKey),
        [widgetType, widgetKey]
    );
    return useCallback(
        (columnId: T, defaultSortDesc: boolean) =>
            dispatch(actionCreator(columnId, defaultSortDesc)),
        [dispatch, actionCreator]
    );
};
